// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Ow3tp","container":"styles_container__16k1o","title":"styles_title__-HnPG","wrapper":"styles_wrapper__iEDhU","answer":"styles_answer__20ICv"};